import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendMicrosoftPush } from 'services/pod';
import { ISendPushNotificationPayload } from 'services/pod/types';
import { ISendErrorPayload, extractSendErrorPayload } from './sendErrorPayload';

export const ThunkSendMicrosoftPush = createAsyncThunk<
  unknown,
  ISendPushNotificationPayload,
  { rejectValue: ISendErrorPayload }
>('pod/sendMicrosoftPush', async (payload, { rejectWithValue }) => {
  try {
    const res = await sendMicrosoftPush(payload);
    return res.data;
  } catch (err) {
    return rejectWithValue(extractSendErrorPayload(err));
  }
});
